// app-routing.module.ts

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { deactivateLoginGuard } from './shared/guards/deactivate-login.guard';
import { SettingsComponent } from './settings/settings.component';

const routes: Routes = [
  {
    canDeactivate: [deactivateLoginGuard],
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'genie',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
    canActivate: [authGuard],
    pathMatch: 'full',
  },
  {
    path: 'settings',
    component: SettingsComponent,
    // loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
    canActivate: [authGuard],
    pathMatch: 'full',
  },
  {
    path: 'error',
    component: PageNotFoundComponent,
    data: {
      title: 'Error Page',
    },
  },
  {
    path: '**',
    redirectTo: 'genie', // Redirect to error page for unknown routes
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
